/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

export default function joinPath(basePath: string, name: string): string {
  if (basePath !== '') {
    return `${basePath}/${name}`;
  } else {
    return name;
  }
}
